import { useQuery } from '@tanstack/react-query';
import api from '../services/api';

// Health of every scheduled integration. Polled rather than fetched once: this
// screen's whole job is answering "did it run / is it healthy right now", and a
// tab left open since this morning showing stale green would defeat the point.
// A minute is far more often than any job runs, and it's a single cheap query.
export function useIntegrations() {
  return useQuery({
    queryKey: ['platform', 'integrations'],
    queryFn: async () => {
      const { data } = await api.get('/api/platform/integrations');
      return data;
    },
    refetchInterval: 60_000,
    refetchOnWindowFocus: true,
  });
}
